<template>
  <div class="height-100">
    <main-template :showSubject="true" :noPick="true" :nomenu="true">
      <template>
        <div class="header_top"><span @click="goPaperAnalysis">试卷分析</span> / 整体分析</div>
        <div class="detail">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="整体分析">
              <div v-for="(item, index) in chartData" :key="index">
                <div class="title">{{ item.chartTitle }}</div>
                <div>
                  <div v-if="item.chart_type === 'pie'" id="mychart"></div>
                </div>
                <a-table
                   v-if="item.chart_type === 'table'"
                   :rowKey="(r, index) => index"
                  :columns="item.dataColumns"
                  :data-source="item.chart_data.data"
                  :pagination="{
                    pageSize: 10,
                    total: item.total
                  }"
                  @change="handlePageChange($event, item.chart_order, item.chartTitle, index)">
                   <template slot="item" slot-scope="item">
                    <span :class="{ detail_label: item.question_ids.length > 0 }" @click="paperDetail(item)">
                      {{ item.label }}
                    </span>
                  </template>
                </a-table>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </template>
    </main-template>
  </div>
</template>

<script>
import MainTemplate from '@/components/MainTemplate.vue'
import * as echarts from 'echarts'
import { statisticsDetail } from './models/api'

export default {
  data() {
    return {
      // 图表数据
      chartData: [],
      // 图表title
      chartTitle: [{
        title: '题型分析',
        id: 1
      }, {
        title: '知识点分布',
        id: 3
      }, {
        title: '知识点分布详情',
        id: 2
      }]
    }
  },
  components: {
    MainTemplate
  },
  // mounted
  mounted() {
    this.getData()
  },
  methods: {
    // 获取所有图表数据
    async getData() {
      const ids = this.$route.query.ids
      const paperIds = ids.split(',')
      if (!paperIds.length || paperIds.length > 12) {
        window.close()
        return
      }
      this.chartData = await Promise.all(this.chartTitle.map(async item => {
        return await this.getStatisticsDetail(paperIds, item.id, item.title, 1)
      }))
      this.chartData.forEach(item => {
        if (item.chart_type === 'pie') {
          this.$nextTick(() => this.drawChart(item.chart_data.data))
        }
      })
    },
    // 获取图表数据
    async getStatisticsDetail(ids, dashboardId, title, page) {
      try {
        const res = await statisticsDetail({
          paper_ids: ids,
          dashboard_id: dashboardId,
          page
        })
        const data = res.data.charts[0]
        if (data.chart_type === 'table') {
          data.dataColumns = data.columns.map(item => ({
            dataIndex: item,
            key: Math.random(),
            title: item,
            width: 200,
            scopedSlots: { customRender: 'item' }
          }))
        }
        data.chartTitle = title
        return data
      } catch (err) {
        return []
      }
    },
    // 面包屑导航
    goPaperAnalysis() {
      window.location.href = '/paperAnalysis'
    },
    // 查看题目
    paperDetail(val) {
      if (!val.question_ids.length) return
      window.open(`/paperAnalysis/question?ids=${val.question_ids.join(',')}`)
    },
    // handlePageChange
    async handlePageChange(val, order, title, idx) {
      const ids = this.$route.query.ids
      const paperIds = ids.split(',')
      const result = await this.getStatisticsDetail(paperIds, order, title, val.current)
      this.chartData[idx] = result
      this.$set(this.chartData, idx, result)
    },
    // 绘制图表
    drawChart(data) {
      const id =  document.getElementById('mychart')
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(id)
      myChart.off('click')
      // 绘制图表
      myChart.setOption({
        legend: {
          type: 'scroll',
          // orient 设置布局方式，默认水平布局，可选值：'horizontal'（水平） ¦ 'vertical'（垂直）
          orient: 'vertical',
          // x 设置水平安放位置，默认全图居中，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
          x: 'left',
          // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
          y: 'center',
          itemWidth: 24, // 设置图例图形的宽
          itemHeight: 18, // 设置图例图形的高
          textStyle: {
            color: '#666' // 图例文字颜色
          },
          // itemGap设置各个item之间的间隔，单位px，默认为10，横向布局时为水平间隔，纵向布局时为纵向间隔
          itemGap: 30,
          data: data.map(item => item.group_by.label)
        },
        series : [
          {
            label: {
              normal: {
                formatter: '{b}：{d}%  ',
              }
            },
            type: 'pie',    // 设置图表类型为饼图
            radius: ['30%', '60%'],  // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
            data: data.map(item => ({
              value: item.value.label,
              name: item.group_by.label,
              ids: item.value.question_ids
            }))
          }
        ]
      })
      // 图表点击事件
      myChart.on('click', params => {
        if (!params.data.ids.length) return
        window.open(`/paperAnalysis/question?ids=${params.data.ids.join(',')}`)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.header_top {
  margin-bottom: 15px;
  font-size: 12px;
  color: #4D5271;
  span {
    color: #A1A3B4;
    cursor: pointer;
  }
}
.detail {
  background: #fff;
  height: 100%;
  width: 100%;
  min-height: 800px;
  padding: 24px;
  border-radius: 4px;
  &_label {
    cursor: pointer;
    &:hover {
      color: #386BFF;
    }
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #2E3458;
    padding-top: 8px;
    padding-bottom: 24px;
  }
  #mychart {
    height: 480px;
  }
}
</style>
